import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';
import { DataSourceAutocomplete } from '@models';

export function useDataSources() {
  return useAutocompleteSource<DataSourceAutocomplete>({
    url: EvidenceApiUrl.DATA_SOURCE + '/autocomplete',
  });
}
